import { render } from "./insure-team-report-add.vue?vue&type=template&id=338676f6&scoped=true&ts=true"
import script from "./insure-team-report-add.vue?vue&type=script&lang=ts"
export * from "./insure-team-report-add.vue?vue&type=script&lang=ts"

import "./insure-team-report-add.vue?vue&type=style&index=0&id=338676f6&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338676f6"]])

export default __exports__